enum LoginFields {
  EMAIL = 'email',
  PASSWORD = 'password',
  REMEMBER_ME = 'rememberMe',
}

export default LoginFields;
